import { createI18n } from "vue-i18n";

// 语言包配置
const messages = {
  en: {
    title: "Cabbeen Designer Brand",
    welcome: "Welcome to our website!",

    home: {
      title: "Home Page",
    },
    store: {
      title: "Store Page",
    },
    contact: {
      title: "Contact Us | 联系我们",
      headOffice: "Cabbeen Malaysia",
      addressLabel: "Address",
      address:
        "S-20-11, WISMA YNH, KIARA 163, 8, Jalan Kiara, Mont Kiara, 50480 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
      navigateBtn: "Open Map Navigation",
    },
    // Contact page bilingual texts
    contactPage: {
      title: "Global Offices",
      cooperationTitle: "Business | 商务合作",
      headquartersTitle: "🏢 公司总部 / Headquarters",
      company: "CABBEEN FASHION (M) SDN BHD",
      contactLabel: "Contact",
      positionLabel: "Position",
      addressLabel: "Address",
      address:
        "L22-01 & 02, Wisma T.S.Law 55100 Kuala Lumpur.",
      emailLabel: "Email",
      email: "cabbeen{'@'}ycinvest.com",
      workHours: "Working Hours: Monday – Friday, 9:00AM – 6:00PM",

      marketingTitle: "📈 市场合作 / Marketing & Partnerships",
      marketingIntro:
        "For media, advertising or event collaborations, please contact our Marketing team:",
      marketingDept: "Marketing Department 市场部",
      marketingContactName: "Ms. Mandy",
      marketingPosition: "Marketing Manager",
      marketingEmail: "cabbeen.marketing{'@'}ycinvest.com",
      whatsappLabel: "WhatsApp",
      whatsappNumber: "+60 1111323755",
      hqCardTitle: "CABBEEN FASHION (M) SDN BHD",
      phoneLabelSimple: "Phone",
      hkCardTitle: "CABBEEN FASHION LIMITED",
      hkAddress: "Unit A, 26/F, Billion Plaza II, 10 Cheung Yue Street, Cheung Sha Wan, Kowloon, Hong Kong",
      hkPhone: "(852) 2319 5624",
      hkEmail: "ir{'@'}cabbeen.com",
      cnCardTitle: "CABBEEN CLOTHING(CHINA)CO.LTD",
      cnAddress: "PRC Guangzhou 510700 Huang Pu District, Guangzhou City No. 8 Kai Tai Da Road 9th Floor, Block C",
      cnPhone: "400-888-9593",
      cnEmail: "service{'@'}cabbeen.com",
      complaintTitle: "Complaints and Suggestions",
      complaintText: "This is a great opportunity for us to understand how we are performing. With your support and assistance, we can promptly correct our shortcomings, enhance our strengths, and provide you with better service.You can provide any requests or feedback directly to our General Manager. The contact email is ",

      leasingTitle: "🏬 招商联络 / Leasing & Expansion",
      leasingIntro:
        "Welcome mall partners, store resource owners, and property agents to discuss Cabbeen store leasing:",
      leasingContactName: "Mrs.Aston",
      leasingPosition: "Leasing Manager",

      joinTitle: "Join Our Team",
      recruitCardTitle: "Join Our Team",
      recruitConceptLabel: "Recruitment Philosophy:",
      recruitConceptText:
        "We are looking for fashion-loving and creative talents to join us.",
      openPositionsLabel: "Open Positions:",
      positions: {
        salesConsultant: "Sales Consultant (Junior/Mid/Senior)",
        storeSupervisor: "Store Supervisor",
        vma: "Visual Merchandising Assistant",
      },
      resumeLabel: "Recruitment Email:",
      phoneLabel: "WeChat/WhatsApp:",
    },
    // Brand cooperation page
    brandCoop: {
      heroTitle:
        "Cabbeen believes in the power of collaboration.\nFrom fashion shows to digital campaigns, we co-create impactful stories with brands, creators, and global media.",
      mediaTitle: "Media Collaborations",
      starTitle: "Celebrities & Creators",
    },
    offlineStore: {
      real: "real",
      navigateBtn: "Navigate to this store",
      reviewTip: "Welcome to rate and review us on Google Maps:",
      reviewAction: "Leave a review",
    },
    findStore: {
      title: "Find a Store",
      description:
        "Find our stores online via platforms like TikTok, Instagram, etc.",
      tiktok: "TikTok",
      instagram: "Instagram",
      amazon: "Amazon",
    },
    financialReport: {
      title: "Financial Report",
      description: "Display financial data and reports here.",
      all: "All",
      loadMore: "Load More",
    },
    productDetail: {
      purchaseContact: "For purchase, please contact:",
    },
    navbar: {
      store: "Store",
      about: "About",
      offlineStore: "Find Store",
      contact: "Contact Us",
      globalHQ: "Global Offices",
      brandCooperation: "Brand Collaboration",
      mallLeasing: "Business Partnership",
      cooperation: "Business",
      recruitment: "Careers",
      financialReport: "Finance",
      login: "Login",
      menFashion: "Men >",
      cabbeenShoes: "Shoes  >",
      newArrivals: "New  >",
      trendAlbum: "Album  >",
      news: "News",
    },
    // Mall Leasing page simple i18n
    mallLeasing: {
      contactTitle: "Business Partnership/Mall Cooperation",
      position: "Business Development Supervisor",
    },
    categories: {
      mensTops: "Men's Tops",
      tshirt: "T-shirt",
      shirt: "Shirt",
      suit: "Suit",
      vest: "Vest",
      jacket: "Jacket",
      polo: "Polo",
      sweatshirt: "Sweatshirt",
      knitwear: "Knitwear",
      casualWear: "Casual Wear",
      mensBottoms: "Men's Bottoms",
      casualPants: "Casual Pants",
      jeans: "Jeans",
      knitPants: "Knit Pants",
      shorts: "Shorts",
      underwear: "Underwear",
      cabbeenShoes: "Cabbeen Shoes",
      casualShoes: "Casual Shoes",
      sneakers: "Sneakers",
      sandals: "Sandals",
      "4dPrintedShoes": "4D Printed Shoes",
      accessories: "Accessories",
      bags: "Bags",
      hats: "Hats",
      belts: "Belts",
      necklaces: "Necklaces",
      socks: "Socks",
      ties: "Ties",
      newArrivals: "New Arrivals",
      celebrityStyle: "Celebrity Style",
      fashionistaDiscount: "Fashionista Limited-time Discount Entrance",
      pointsGifts: "Points Gifts",
      pointsGift: "Points Gift",
    },
    footer: {
      company: "CABBEEN FASHION (M) SDN BHD",
      address:
        "Address: L22-01 & 02, Wisma T.S.Law 55100 Kuala Lumpur.",
      mobile: "Mobile: 03-8681 6097",
      emailLabel: "E-mail",
      website: "Website: WWW.CABBEENMY.COM",
      code: "Code: 2030.HK",
      followUs: "Follow us:",
      terms: "© Copyright 2025 CABBEEN FASHION (M) SDN BHD",
        // Footer right nav (PC only)
        nav: {
          shopTitle: "Cabbeen Store",
          contactTitle: "Contact Us",
          aboutTitle: "About Cabbeen",
          // Shop submenu
          onlineStore: "Online Store",
          lazada: "Lazada",
          shopee: "Shopee",
          tiktokShop: "TikTok Shop",
          // Contact submenu
          globalHQ: "Global Offices",
          brandCooperation: "Brand Collaboration / Media & Ads",
          mallLeasing: "Business Partnership / Franchising",
          recruitment: "Careers",
          // About submenu
          offlineStore: "Find Store",
          news: "News",
        },
    },

    //明星大图
    celebrityTitleHtml: '<span class="en">CELEBRITY STYLE</span>',
    // 品牌价值观
    values: {
      items: [
        {
          title: "CONCEPT",
          description: "Reshape the trend",
        },
        {
          title: "VISION",
          description: "Build a global fashion brand with Chinese culture.",
        },
        {
          title: "MISSION",
          description:
            "Focus on quality, pursue design creativity, and continue to meet people's needs for multi-scenario wear.",
        },
        {
          title: "CORE VALUES",
          description:
            "We work in fashion, pursue a tasteful life, and constantly improve and surpass ourselves. We create a personalised, harmonious and simple working environment.We are grateful, serve the community, and work hard to create a new force of fashion in China.",
        },
        {
          title: "Overseas Expansion Plan",
          description:
            "Starting from Kuala Lumpur, CABBEEN expands across Southeast Asia — Indonesia, Singapore, Thailand, Vietnam, and Cambodia.With full resource investment and strong brand exposure,CABBEEN creates 500+ local jobs and drives Chinese fashion onto the global stage.",
        },
      ],
    },
    about: {
      look: "View",

      intro: [
        "Cabbeen Fashion (referred to as Cabbeen) was founded in 1997. With its brand philosophy of “disrupting trends,” its forward-thinking approach to individualistic fashion, and its dedication to original design, Cabbeen has grown into one of China’s leading designer brands today. In February 2007, Cabbeen became the first Chinese designer brand to appear at New York Fashion Week. In October 2013, Cabbeen was successfully listed in Hong Kong, becoming the first Chinese fashion designer brand to be publicly listed in Hong Kong (Stock Code: 2030).",
        "As an iconic designer brand that grew from China’s domestic market, Cabbeen focuses on original design, brand operations, and developing diverse retail channels for apparel, footwear, and accessories. In the authoritative rankings by the China National Garment Association, Cabbeen has consistently ranked among the industry leaders, thanks to its outstanding retail performance, extensive retail network, and strong brand influence — fully demonstrating its leading position in China’s fashion industry.",
        "Since its establishment, Cabbeen has adhered to the business philosophy of “enhancing brand value as the core of operations and developing human resources as the foundation of management,” continually building and refining an international business model. The company has developed a multi-brand portfolio centered around Cabbeen, including 2AM, 1%, Cabbeen Love, Cabbeen Home, KOYO, MARKET LIBERTY, and thisisIZI8, extending into the fields of stylish home living and lifestyle services.",
        "To enable overseas consumers to conveniently experience and purchase Cabbeen’s fashion, the brand officially announced the opening of its first overseas store at Pavilion Bukit Jalil in Kuala Lumpur, Malaysia. The grand opening ceremony, held on June 8, marks a key milestone in Cabbeen’s international expansion strategy.",
      ],
    },
    news: {
      look: "View",
      // 关于卡宾页面中的新闻模块卡片
      cards: [
        {
          title:
            "Cabbeen’s First Overseas Store Opens Its Doors in Malaysia’s Pavilion Bukit Jalil",
          summary:
            "Cabbeen Fashion, as a leading designer fashion brand in China, celebrated the grand opening of its first overseas store on June 8 at Pavilion Bukit Jalil in Kuala Lumpur....",
        },
        {
          title:
            "In 2013, A Designer Brand of China , CABBEEN was listed on the Hong Kong Stock Exchange.",
          summary:
            "On October 28, 2013, as one of China’s leading original designer brands, CABBEEN was officially listed on the Hong Kong Stock Exchange...",
        },
        {
          title:
            "CABBEEN has become the first Chinese designer brand to showcase at New York Fashion Week.",
          summary:
            "At 20:00 on February 3, 2007, New York time, the Chinese menswear brand CABBEEN held its 2007/08 autumn and winter fashion show at New York Fashion Week...",
        },
        {
          title:
            "2024 FW / Maritime Silk Road Landscape \"Return to the Heart\"Autumn-Winter Show",
          summary:
            "In recent years, Quanzhou has become a popular tourist destination, attractingyoung consumers with its rich historical and cultural heritage and urban charm...",
          link: "/news/malaysia"
        },
        // 2025SS 新增卡片（英文）
        {
          title: "CABBEEN x Feng Chen Wang 2025 Spring/SummerCollaboration New Arrival",
          summary: "CABBEEN x Feng Chen Wang 2025 Spring/Summer Collaborative CollectionReleased [Homemade 3.0]",
          link: "/news/2025-ss"
        },
        // Thumbs Up（英文）
        {
          title: "Thumbs Up! CABBEEN Assists in the Successful Launch of the Long March 8 Y3 Rocket!",
          summary: "In 2024, at 8:31 AM on March 20, the Quegiao-2 relay satellite of the fourthphase of the lunar exploration program was successfully launched by the Long...",
          link: "/news/thumbsup"
        },
        // Beijing Winter Olympics (English)
        {
          title: "Assisting in the Production of Flag Bearer Uniforms for theBeijing Winter Olympics",
          summary:
            "he 2022 Beijing Winter Olympics opening ceremony showcased thetechnological prowess of \"Made in China.\" CABBEEN utilized \"Internet\".",
          link: "/news/bjwo"
        },
      ],
      malaysia: {
        title:
          "Cabbeen’s First Overseas Store Opens Its Doors in Malaysia’s Pavilion Bukit Jalil",
        content1:
          "Cabbeen Fashion, one of China’s leading designer fashion brands, celebrated the grand opening of its first overseas store on June 8 at Pavilion Bukit Jalil in Kuala Lumpur. Since its founding in 1997, Cabbeen has embraced a brand philosophy of “youth, fashion, and individuality,” blending Eastern aesthetics with global trends— earning the love of urban men around the world. The brand’s entry into Malaysia marks an important milestone in its international expansion strategy, aiming to provide Malaysian consumers with a fresh shopping experience that fuses trendsetting style and refined lifestyle taste.",
        content2:
          "Cabbeen not only commands strong brand recognition in China but has also expanded its fashion influence across multiple countries and regions in Asia. In Malaysia, in particular, Cabbeen has quickly won widespread recognition and affection from local consumers.",
        content3:
          "To make it more convenient for Malaysian shoppers to experience and purchase Cabbeen’s collections, the brand officially announced its first overseas store at Pavilion Bukit Jalil in Kuala Lumpur, with a grand opening ceremony held on June 8 — marking a key step forward in Cabbeen’s global growth strategy.",
        content4:
          "Cabbeen’s first overseas store was established at Pavilion Bukit Jalil in Kuala Lumpur and held its grand opening ceremony on June 8.",
        content5:
          "Mandy Mao, Marketing General Manager of Cabbeen Fashion (Malaysia) Sdn. Bhd. While delivering her speech at the event highlighted that since its founding, Cabbeen has been dedicated to creating a stylish and attitude-driven dressing experience for a new generation of urban men.",
        content6:
          "Mandy Mao: “After more than 20 years of steady growth, Cabbeen has built a strong brand presence in cities around the world and has won widespread recognition and support.”",
        content7:
          "She added, “Today, Cabbeen’s official debut in Malaysia marks not only a key milestone in our international expansion strategy but also reflects our strong commitment and confidence in the Southeast Asian fashion market. Kuala Lumpur — a vibrant, multicultural city with a keen sense of style — is the ideal stage for Cabbeen to open this exciting new chapter. I would especially like to thank our local partners in Malaysia, our retail team, and every colleague who poured their passion and professionalism into making this store a reality. It is your dedication that brought this flagship from concept to grand opening so perfectly.”",
        content8:
          "Distinguished guests in attendance included Mr. Lovell Ho, Senior Leasing Director of Pavilion, CABBEEN Executive Director Mr. Keith Hooi, Executive Assistant Ms. Kelley Thong, Store Managers Mr. Michael Chu and Mr. Benson Foo, among others.",
        content9:
          "From left (second to sixth): Benson Foo, Michael Chu, Keith Hooi, Lovell Ho, Mandy Mao, and Kelley Thong officiate the ribbon-cutting ceremony for CABBEEN’s first overseas flagship store.",
        content10:
          "■ 25 Years of Design Legacy, 3 Years of Planning — Now Officially Launched",
        content11:
          "Later, in an exclusive interview with China Press, Mandy revealed that CABBEEN aims to blend Eastern design aesthetics with global fashion trends to deliver a fresh and exciting shopping experience for local consumers. She also shared that CABBEEN’s entry into Malaysia marks the starting point of its broader strategy to expand across the Southeast Asian market. Over the next three years, the brand plans to establish a presence in Indonesia, Singapore, Thailand, Vietnam, and Cambodia, positioning Malaysia as its regional hub for trendsetting design and marketing in Southeast Asia.",
        content12:
          "Mr. Lovell Ho also personally tried on CABBEEN’s apparel, experiencing its unique design and fashionable appeal firsthand.",
        content13:
          "When asked why CABBEEN chose Malaysia for its first overseas store, she explained that the decision was based on several factors. “First, the shared language and cultural similarities significantly lower the communication barriers between us and the local market and consumers. Moreover, Malaysia’s unique multicultural heritage — where Chinese, Malay, and Indian aesthetics blend harmoniously — aligns perfectly with CABBEEN’s brand DNA of ‘Eastern aesthetics, global expression.”",
        content14:
          "“At the same time, we place great importance on nurturing local talent and creating job opportunities. Through CABBEEN’s presence and operations here, we hope to help drive the development of the local retail, fashion, and related service industry, while building a bridge of friendship between China and Malaysia — fostering deeper and more diverse bilateral ties through the medium of our brand.”",
        content15:
          "“As for choosing Pavilion Bukit Jalil as the location for our first overseas store, it offers multiple advantages as an emerging commercial hub: strong growth potential, high foot traffic, and a vibrant business environment. In Malaysia’s premium fashion market, there is still a lack of brands dedicated exclusively to menswear. CABBEEN hopes to fill this gap, spark new possibilities, and open an exciting new chapter for our brand in Malaysia.”",
        content16:
          "CABBEEN’s first overseas store celebrates its grand opening, attracting crowds of visitors eager to explore and snap photos.",
        content17:
          "“Over the next three years, CABBEEN will steadily expand its brand presence in Malaysia, with plans to open six stores within two years and to have a presence in cities across the country within three years. We see Malaysia as a key starting point for CABBEEN’s international strategy,” she explained. “We will be making significant investments in advertising here, with an initial budget of no less than RM30 million. This will focus on three main areas: establishing a strong brand image through our store facades and recognizable visual identity, building brand awareness quickly through celebrity endorsements and collaborations with influencers — combining entertainment and social media promotion — and actively engaging in local community initiatives. Through these concrete actions, we hope to give back to society and build closer connections with local consumers.”",
        content18:
          "She also revealed that the next major focus will be preparing for a large-scale fashion show hosted by CABBEEN’s headquarters in Quanzhou, Fujian, China.",
        content19:
          "“We will be inviting our business partners and friends to attend the event. In addition, we will gradually roll out our store expansion plan and, when the time comes, we plan to invite TVB artists from Hong Kong or celebrities from mainland China to officiate ribbon-cutting ceremonies, further boosting our brand’s visibility and public interest. These activities will help strengthen our presence in the local market,” she said.",
        content20:
          "She added that in terms of location strategy, the first phase will focus on establishing a strong presence in Kuala Lumpur as the core hub, before expanding step by step to other major cities such as Johor Bahru, Penang, and Melaka — aiming to cover Malaysia’s key markets comprehensively. CABBEEN also plans to launch its online sales channels next year, enabling an integrated online and offline strategy to offer consumers a more convenient and diverse shopping experience.",
        content21:
          "“At CABBEEN, we firmly believe that ‘every task is worth doing well with focus and dedication.’ That’s why, at this stage, our top priority is the steady development of our core CABBEEN brand and building a solid foundation in the Malaysian market. Once we have established this strong base, we will then consider introducing our other sub-brands at the right time — such as 2AM, which targets a younger demographic, and CABBEEN Love, which focuses on children-swear — to gradually expand our brand portfolio,” she said.",
        content22:
          "When asked about what sets CABBEEN apart from other menswear brands, Mandy said she believes CABBEEN’s greatest strength lies in striking the ideal balance between distinctive design and quality craftsmanship.",
        content23:
          "“Our positioning sits within an accessible and reasonable premium segment, making it easy for more consumers to own fashion pieces that are both stylish and practical. CABBEEN has always maintained high standards when it comes to details, fabrics, and wearing comfort. Take our store’s collection, for example — from business polos to sporty casual jackets — each piece fully embodies CABBEEN’s design philosophy of ‘attitude and style.’ Many customers might worry that long-sleeve pieces could feel too warm at first glance, but in fact, we use lightweight and breathable fabrics that ensure excellent comfort even in Southeast Asia’s hot and humid climate. They’re perfect for outdoor activities or sportswear,” she explained.",
        content24:
          "She added that CABBEEN is not just a fashion brand, but also a reflection of a lifestyle and a sense of cultural taste. She hopes that everyone who wears CABBEEN pieces will not only express their style but also feel a sense of spiritual connection and identity.",
        content25:
          "“We hope that CABBEEN will not only become a menswear brand loved by Malaysian consumers but also create a fashion space that brings together trends, aesthetics, and cultural experiences. We want everyone who steps into our stores to enjoy a customer-first shopping experience while also feeling the lifestyle and brand spirit that CABBEEN stands for,” she said.",
        content26:
          "After the lion dance and “cai qing” blessing ceremony, distinguished guests and CABBEEN staff posed for a group photo, wishing the brand a prosperous business and a successful grand opening.",
      },
      nyShow: {
        title:
          "CABBEEN has become the first Chinese designer brand to showcase at New York Fashion Week.",
        content1:
          "At 8:00 PM on February 3, 2007, New York time, the Chinese menswear brand CABBEEN held its 2007/08 autumn/winter fashion show at New York Fashion Week. Models and fitters in the backstage, as well as the main designer Mr. Cabbeen and the CABBEEN performance delegation, received widespread attention. This marks the first appearance of a Chinese designer brand at the globally renowned New York Fashion Week, known for its fashion and commercial significance.",
        content2:
          "The 40 sets of 2007/08 autumn and winter menswear showcased by CABBEEN at their press conference boldly and uniquely interpreted elements of Chinese traditional culture, shocking and earning praise from the international fashion community and professional media. The New York Post wrote in its preview of Fashion Week: “There are over 130 shows at New York International Fashion Week, with ten must-see shows, and CABBEEN menswear ranks in the top five.” The magazine “VOGUE,” praised by designers, writers, and artists as an authority on style and fashion, also made a feature report titled “Chinese Brand Debuts at New York Fashion Week.”",
      },
      fw2024: {
        title:
          "2024 FW / Maritime Silk Road Landscape \"Return to the Heart\"Autumn-Winter Show",
        content1:
          "In recent years, Quanzhou has become a popular tourist destination, attracting young consumers with its rich historical and cultural heritage and urban charm. Numerous celebrity variety shows have filmed in Quanzhou, and more fashion brands and magazines are flocking to the city to host high-profile fashion events and photo shoots, further amplifying Quanzhou's cultural appeal.",
        content2:
          "Mr. CABBEEN, also from Quanzhou, chose to return to his hometown of Shishi to host the CABBEEN 2024/25 Autumn-Winter Show, bringing a refreshing surprise to the runway and sparking widespread attention and discussion in the fashion industry, quickly becoming a hot topic.",
        content3:
          "Notably, on October 25, stars such as Bi Wenjun, Chen Xiaodong, Jike Junyi, Liang Hanwen, Lin Xiaofeng, Lü Songxian, Ma Su, Wu Xuanyi, Xiang Zuo, and Zhang Liang (listed in alphabetical order) attended the 'Return to the Heart' CABBEEN show at the Linluan Pier in Shishi, Quanzhou. The star‑studded lineup became a standout element of the show, bringing immense exposure and attention to CABBEEN and Quanzhou, bridging the gap between the brand and consumers.",
        content4:
          "Additionally, over 50 fashion bloggers, senior executives from national shopping centers, publishers of major fashion magazines, founders of clothing brands, e‑commerce platforms, fashion media, and business media attended the show, witnessing the 'Return to the Heart' and CABBEEN's dazzling 27th anniversary.",
        content5: '"Return to the Heart" Maritime Silk Road Show',
        content6: 'Creating a New Runway Experience',
        content7:
          "Looking back at the brand's history, CABBEEN has consistently delivered countless spectacular brand launches. In 2007, it became the first Chinese designer brand to walk at New York Fashion Week. In 2015, it hosted the 'Funfair' carnival‑themed show. In 2021, it presented the 'New World View' urban street show. We have seen CABBEEN build various fashion stages with original designs and limitless creativity, each with different themes, concepts, and forms.",
        content8:
          "This time, the brand once again broke from tradition. Mr. CABBEEN collaborated with renowned national director Xiao Xiangrong to host the CABBEEN 2024/25 Winter Show at the Linluan Pier in Shishi, Quanzhou, a key node of the Maritime Silk Road, under the theme 'Return to the Heart'. The show presented a new narrative through the collision of historical culture and fashion art.",
        content9:
          "As the birthplace of the Maritime Silk Road, Quanzhou's Shishi is steeped in legendary cultural stories. The show's location, Linluan Pier, built during the Tang Dynasty and over a thousand years old, spans 113.5 meters. It served as an important bridge for cultural exchange between East and West and witnessed countless cultural integrations and historical changes. It reflects Mr. CABBEEN's deep affection for his hometown and his contemplation and vision for the brand's 27‑year journey.",
        content10:
          "Before the show, Mr. CABBEEN graced the cover of Men's Uno (Fengdu) magazine and filmed a short‑video trilogy—'Seeing the World', 'Seeing the Heart', and 'Seeing the Action'—expressing his love for his hometown and his aspiration for 'returning to the heart'.",
        content11:
          "The phrase 'Half the city is bustling, half the city is like a fairyland' perfectly interprets Quanzhou's unique charm. Mr. CABBEEN said, 'Quanzhou is not only known for its cuisine, but also for world cultural heritage, folk traditions, and the unique hairpin flower culture. The 'bustling half' describes the diligence and simplicity of Minnan people, while the 'fairyland half' reflects Quanzhou's great inclusiveness that welcomes people from all over the world to start businesses and live here.'",
        content12:
          "On the day of the show, Mr. CABBEEN and the creative team extended the runway onto the sea for the first time, transforming the thousand‑year‑old pier into a magnificent stage. With CABBEEN Yellow as the main tone and a giant double 'C' logo on the pier, accompanied by splendid intangible cultural heritage performances, the audience, led by 'dancers of time', walked from the old pier to the new one and experienced an immersive Maritime Silk Road landscape show at sunset.",
        content13:
          "Mr. CABBEEN said, 'The integration of the old and new piers is like the trajectory of my life—from a powerful boxing youth to building the CABBEEN Group. Chinese culture, as the foundation of CABBEEN, constantly nourishes my works. I will always lead the brand with Chinese culture as its DNA to bring more original Chinese designs.'",
        content14: 'Using Chinese culture as a link — Opening a new chapter of cross‑border co‑branding',
        content15:
          "Focusing on the new products released at the show, CABBEEN once again brought many surprises. The biggest highlight of the night was the 2025 Spring/Summer co‑branded collection MADE IN MY TOWN 3.0 'Made in Hometown 3.0', jointly launched by CABBEEN and the international fashion week brand FengChenWang, which became the most eye‑catching element of the event.",
        content16:
          "The grand debut of this co‑branded series takes inspiration from Quanzhou, the common hometown of Mr. CABBEEN and designer FengChenWang. It skillfully extracts the essence of Fujian tea colors, integrates FengChenWang's signature deconstruction and splicing, and CABBEEN's distinctive washing techniques to create a pioneering outdoor casual style and present a brand‑new multi‑category collection.",
        content17:
          "As FengChenWang's only domestic co‑branding partner, CABBEEN has worked with the brand since their first collaboration in 2020 to create several joint series. In January, CABBEEN, together with the media 'Urbanite', also chose Quanzhou to hold the 'Urbanite Family Banquet' launch event for the CABBEEN × FengChenWang 2024 Spring Designer Co‑branded Series 'Made in Hometown 2.0'.",
        content18:
          "Next came the CABBEEN × China Rocket 2024 Winter co‑branded series 'Polar Explorer'. Continuing the narrative of cosmic polar exploration, the brand drew inspiration from cosmic signal waves, lunar landforms, and future spacesuits to design a textured 'Polar Explorer' series—jackets, vests, and down jackets in a space‑outdoor aesthetic.",
        content19:
          "In addition, CABBEEN unveiled the new 'Fleece Players' series and the Sayram Lake down series. These releases represent CABBEEN and Mr. CABBEEN's tribute to Chinese strength and their fresh interpretation of fashion.",
        content20:
          "It is evident that CABBEEN places great emphasis on exploring traditional culture and integrating it with the versatility of clothing—attempting to bridge Chinese culture and fashion language through repeated cross‑border collaborations to maintain freshness and 'break the circle' for the rapidly changing market.",
        content21:
          "Chinese culture has always been the foundation of the CABBEEN brand. Mr. CABBEEN continues to lead the brand with Chinese culture as its DNA, consistently creating original Chinese designs. In 2024, CABBEEN's co‑branding initiatives continued with popular collaborations such as 'CABBEEN × China Rocket' and 'CABBEEN × FengChenWang', further deepening consumer awareness and narrowing the distance with consumers.",
        content22:
          "Following the show's success, CABBEEN's original design once again became a hot topic across media platforms. Hashtags such as #CABBEEN 2024/25 Autumn and Winter Fashion Show and #CABBEEN Fashion Show in Shishi quickly trended, while more than 400 core business districts and over 800 stores nationwide synchronized promotions to enhance participation both online and offline.",
        content23: 'Continuously building brand power — Deepening brand value',
        content24:
          "Looking back on 2023, Mr. CABBEEN spearheaded a global brand upgrade: reviving the double 'C' logo, refreshing VI, accelerating collaborations, and upgrading products, visuals, content, and store images—bringing the brand to new heights and delivering a fresh visual impact.",
        content25:
          "In terminal channel image upgrades, 2024 again saw major breakthroughs. With 'CABBEEN Yellow' as the core, the distinctive brand impression strengthened. Through youthful and trendy spatial scenes, brand value further permeated consumer perception.",
        content26:
          "Recently, the national flagship store at Grandview Mall Guangzhou opened with a subversive new image, building a multi‑category space that integrates sight, hearing, and smell for an immersive experience. It features the nation's first naked‑eye 3D spherical screen and the first flagship VIP room, debuting ten VIP privileges. Since opening, sales increased 30% YoY and new members 25%.",
        content27:
          "As of this report, CABBEEN operates 650 stores nationwide, 420 in shopping malls. In 2025, the plan is to open 150 more stores, further densifying core business district coverage and enhancing brand influence.",
        content28:
          "2024 marks CABBEEN's 27th anniversary. Mr. CABBEEN continues to bring original designs and new surprises, contributing to China's fashion industry. This Maritime Silk Road landscape show symbolizes CABBEEN's determination to stay true to its original aspiration—connecting with the world from Shishi, Quanzhou.",
      },
      // 2025SS 详情（英文占位，后续可补充更多段落）
      ss2025: {
        title: "CABBEEN x Feng Chen Wang 2025 Spring/SummerCollaboration New Arrival",
        summary:
          "CABBEEN x Feng Chen Wang 2025 Spring/Summer Collaborative CollectionReleased [Homemade 3.0]",
      },
      // Thumbs Up 详情（英文）
      thumbsup: {
        title: "Thumbs Up! CABBEEN Assists in the Successful Launch of the Long March 8 Y3 Rocket!",
        summary:
          "In 2024, at 8:31 AM on March 20, the Quegiao-2 relay satellite of the fourthphase of the lunar exploration program was successfully launched by the Long...",
        content1:
          "In 2024，at 8:31 AM on March 20, the Queqiao-2 relay satellite of the fourth phase of the lunar exploration program was successfully launched by the Long March 8 Y3 carrier rocket from the Wenchang Space Launch Site in China. After 24 minutes of flight, the rocket separated from the satellite, directly sending the Queqiao-2 relay satellite into the planned Earth-Moon transfer orbit. The relay satellite's solar panels and communication antenna deployed successfully, marking the complete success of the mission.",
        content2:
          "The Launch of the Long March 8 Y3 Rocket test team took a group photo with the rocket",
        content3:
          "Supporting Long March 8, Building the \"Magpie Bridge\".",
        content4:
          "CABBEEN, with Guangdong Design, Empowers China's Aerospace Industry.",
        content5:
          "As a Chinese designer brand, CABBEEN has been closely following the development of China's aerospace industry. Since 2021, CABBEEN has been designing and developing professional team uniforms for rocket test team members, using original Chinese design and advanced clothing technology to interpret the spirit of Chinese aerospace. For this launch mission, Mr. CABBEEN, the brand owner of CABBEEN and a consultant for the Guangdong Garment and Apparel Industry Association, was invited to design the uniforms for the Long March 8 Y3 rocket test team, building a \"heart-to-heart bridge\" with the test team members.",
        content6:
          "Mr. CABBEEN Receives Honorary Certificate from the Long March 8 Y3 Rocket Team",
        content7:
          "New Uniforms Designed by Mr. CABBEEN for the Long March 8 Y3 Rocket Test Team",
        content8:
          "Long March 8 Y3 Rocket Test Team Members Wearing the New Uniforms",
        content9:
          "CABBEEN has always adhered to the vision of \"using Chinese culture to establish a world-class fashion brand,\" committed to enhancing the national image and conveying cultural confidence through original Chinese designs.Soar into the sky and pursue the dream, aim at the vast firmament. On the path of exploration, we walk hand in hand with one heart! CABBEEN fully leverages the power of original Chinese design to showcase the confidence and strength of aerospace professionals through clothing, contributing to the development of China's aerospace industry and national endeavors with the power of Guangdong's fashion industry! ",
        content10: "Salute to China's space program",
        content11: "Thumbs up for Cabbeen!",
        content12: "Thumbs up for Guangdong clothing!",
      },
      // Beijing Winter Olympics detail (English)
      bjwo: {
        title: "Assisting in the Production of Flag Bearer Uniforms for the Beijing Winter Olympics",
        summary:
          "The 2022 Beijing Winter Olympics opening ceremony showcased the technological prowess of \"Made in China.\" CABBEEN utilized \"Internet+\" technology and a fully digitalized, automated \"smart manufacturing\" factory to collaborate with designer WangFengchen in creating the flag bearer uniforms, presenting an image that balanced fashion and solemnity.",
        content1: "Scene from the Beijing Winter Olympics Opening Ceremony",
        content2:
          "The 2022 Beijing Winter Olympics opening ceremony showcased the technological prowess of \"Made in China.\" CABBEEN utilized \"Internet+\" technology and a fully digitalized, automated \"smart manufacturing\" factory to collaborate with designer WangFengchen in creating the flag bearer uniforms, presenting an image that balanced fashion and solemnity.",
        content3:
          "The Olympic flag bearer uniforms were designed by young designer WangFengchen and produced by CABBEEN. The artistic printed down jackets featured a reinterpretation of the classic painting A Thousand Li of Rivers and Mountains, which not only depicted the vast rivers and rolling mountains of the time but also symbolized the harmony between humans and nature, and the interconnectedness of the world.",
        content4:
          "Designer WangFengchen used traditional Chinese landscape painting elements as the background, applying gradient color techniques and embedding line-drawing art forms to depict representative Chinese historical buildings and iconic Olympic structures, bridging the gap between history and modernity.",
        content5:
          "CABBEEN employed \"Internet+\" technology and a fully digitalized, automated \"smart manufacturing\" factory to bring the designer's vision to life, blending tradition with a unique, modern aesthetic.",
        content6:
          "Mr. CABBEEN stated that participating in the production of the Beijing Winter Olympics opening ceremony uniforms broadened his perspective on clothing. \"We hope that in the future, clothing will not only be about appearance but also function, combining aesthetics with practicality.\"",
        content7: "Mr. CABBEEN",
        content8: "Owner of CABBEEN, Renowned Chinese Designer, and Golden Top Award Winner",
        content9: "Q - Beijing Youth Weekly",
        content10: "A - Mr. CABBEEN",
        content11:
          "Q: Regarding the text about the Winter Olympics flag bearers, the concept of a \"smart manufacturing factory\" was mentioned. What was the original intention behind creating such a factory, and what are the characteristics of the clothing produced there?",
        content12:
          "A: In modern society, everything changes rapidly. We keep pace with the progress of the times, and the craftsmanship and technology will also be updated accordingly. The establishment of the \"Intelligent Manufacturing Factory\" is both a breakthrough and a step forward. For instance, this time, CABBEEN has utilized the \"Internet Plus\" technology. The \"Intelligent Manufacturing\" factory, which features full-process digitization and system automation, applies the most cutting-edge technologies to the design and production process. It uses exquisite and rigorous craftsmanship to create clothing that combines functionality and comfort. For example, once the design plan is finalized, the delivery can be completed within one month with guaranteed quality and quantity. Another example is that the five-ring logo on the front chest is made with the most advanced heat transfer printing process.",
        content13:
          "Advances in technology have increased production speed, enabling materials to be quickly available and allowing rapid production of 8+8 sample sets and bulk orders within a short period (5-7 days); the printing patterns are arranged by the Cabbeen team to meet multi-size requirements; the challenge of heat-transferring the Five Rings logo was overcome: the pattern is small, the down-and-synthetic fabric is very slippery, and there was significant risk regarding the durability of the transfer. After testing by multiple process factories and numerous trials, the final result met the standard.",
        content14:
          "Q: What preparations did you make for the Winter Olympics design? What traditional Chinese elements did you incorporate, and how did you collaborate with designer WangFengchen?",
        content15:
          "A: WangFengchen is one of China's leading avant-garde designers and a long-time collaborator with CABBEEN. Coincidentally, we are both from Fujian, and our shared vision led us to collaborate again on the Winter Olympics uniforms. WangFengchen designed the uniforms, while CABBEEN handled the production, working together to support the Winter Olympics.",
        content16: "Designer WangFengchen and flag guards in the background",
        content17:
          "Q: How did you combine traditional Chinese elements with a contemporary, futuristic aesthetic? How did you balance Chinese cultural elements with the icy, winter theme while looking to the future?",
        content18:
          "A: The flag bearer uniforms we created consisted of an artistic printed down jacket and a white Chinese-style suit. The inspiration came from a reinterpretation of A Thousand Li of Rivers and Mountains. This classic painting not only depicted the vast rivers and rolling mountains of its time but also symbolized the harmony between humans and nature, and the interconnectedness of the world. WangFengchen used traditional Chinese landscape painting elements as the background, applying gradient color techniques and embedding line-drawing art forms to depict representative Chinese historical buildings and iconic Olympic structures, bridging the gap between history and modernity. These classic Chinese elements, combined with the icy theme, broke away from outdated stereotypes and presented a fresh, modern image of China.",
        content19:
          "The clothing for the Winter Olympics also has a functional feature, which is warmth retention. Nowadays, it is widely said on the Internet that the Winter Olympics is a \"competition\" of down jackets. How is the warmth retention achieved in terms of technology? What's your opinion on technological innovation?",
        content20:
          "In the past, down jacket technology focused mainly on warmth. Our down jacket technology emphasizes functional upgrades, using DuPont Teflon's top-tier three-proof fabric and 3D lotus nano-effect technology (a biomimetic technology inspired by the smoothness and water-repellent properties of lotus leaves). These fabrics provide excellent protection against cold, wind, and water.",
        content21:
          "As times change, technological advancements are natural. With the evolution of our lifestyles, brands must upgrade their technologies to improve product quality and meet customer demands. Beyond technology, CABBEEN's designs continue to challenge trends. Under the \"unchanging\" core of the brand, we constantly push the boundaries of technology and design, striving to develop original Chinese designs.",
      },
      hklisting: {
        title:
          "In 2013, A Designer Brand of China , CABBEEN was listed on the Hong Kong Stock Exchange.",
        content1:
          "On October 28, 2013, as one of China’s leading original designer brands, CABBEEN was officially listed on the Hong Kong Stock Exchange.",
        content2:
          "As early as the 1990s, a wave of change in men’s aesthetics swept the globe, challenging centuries of conventional, purely functional menswear design. CABBEEN was among the first to take this bold step forward in China, redefining the male silhouette with designs that accentuated the body’s lines for a better fit. CABBEEN’s signature menswear waistline design became a watershed moment in China’s menswear history — reshaping the concept of masculine beauty and forging a new image for modern Chinese men.Looking back at CABBEEN’s journey, it’s clear that the brand has always stayed true to its philosophy of “disrupting trends.” Not only has it consistently broken old conventions in design, but it has also dared to push boundaries in its operations and management. CABBEEN’s successful public listing in Hong Kong reflects the brand’s fearless drive to forge ahead and its unwavering confidence to lead the way.",
      },
    },
  },
  zh: {
    title: "卡宾设计师品牌",
    welcome: "欢迎访问我们的官网!",
    home: {
      title: "首页",
    },
    store: {
      title: "精品店页面",
    },
    contact: {
      title: "Contact Us | 联系我们",
      headOffice: "Cabbeen Malaysia",
      addressLabel: "公司地址",
      address:
        "L22-01 & 02, Wisma T.S.Law 55100 Kuala Lumpur",
      navigateBtn: "打开地图导航",
    },
    // 联系我们页面（双语）
    contactPage: {
      title: "全球总部",
      cooperationTitle: "Business | 商务合作",
      headquartersTitle: "🏢 公司总部 / Headquarters",
      company: "CABBEEN FASHION (M) SDN BHD",
      contactLabel: "联系人",
      positionLabel: "职位",
      addressLabel: "公司地址",
      address:
        "L22-01 & 02, Wisma T.S.Law 55100 Kuala Lumpur",
      emailLabel: "邮箱",
      email: "cabbeen{'@'}ycinvest.com",
      workHours: "工作时间: Monday – Friday, 9:00AM – 6:00PM",

      marketingTitle: "📈 市场合作 / Marketing & Partnerships",
      marketingIntro:
        "如有媒体、广告、活动合作需求，欢迎联系我们的市场部团队：",
      marketingDept: "Marketing Department 市场部",
      marketingContactName: "Ms. Mandy",
      marketingPosition: "市场经理 Marketing Manager",
      marketingEmail: "cabbeen.marketing{'@'}ycinvest.com",
      whatsappLabel: "WhatsApp",
      whatsappNumber: "+60 1111323755",
      hqCardTitle: "卡宾（马来西亚）公司",
      phoneLabelSimple: "电话",
      hkCardTitle: "卡賓服飾有限公司",
      hkAddress: "香港九龍長沙灣長裕街10號億京廣場二期26樓A室",
      hkPhone: "(852) 2319 5624",
      hkEmail: "ir{'@'}cabbeen.com",
      cnCardTitle: "卡宾服饰（中国）有限公司",
      cnAddress: "广州市黄埔区开泰大道8号卡宾时尚中心(510000)",
      cnPhone: "400-888-9593",
      cnEmail: "service{'@'}cabbeen.com",
      complaintTitle: "投诉与建议",
      complaintText: "这是一个很好的机会，让我们知道我们的工作情况。有了您的支持和帮助，我们就可以及时改正缺点，发扬优点，更好地为您提供服务。您有任何的述求都可以像我们的董事长反馈 联络方式为：",

      leasingTitle: "🏬 招商联络 / Leasing & Expansion",
      leasingIntro:
        "欢迎商场方、店铺资源方、物业代理联系 Cabbeen 品牌入驻事宜：",
      leasingContactName: "Mrs.Aston",
      leasingPosition: "招商经理 Leasing Manager",

      joinTitle: "加入我们",
      recruitCardTitle: "人才招募",
      recruitConceptLabel: "品牌招聘理念：",
      recruitConceptText:
        "我们正在寻找热爱时尚、充满创意的伙伴加入我们的团队。",
      openPositionsLabel: "开放职位：",
      positions: {
        salesConsultant: "销售顾问（初级/中级/高级）",
        storeSupervisor: "店铺主管",
        vma: "视觉陈列助理",
      },
      resumeLabel: "招聘邮箱：",
      phoneLabel: "微信/WhatsApp：",
    },
    // 品牌合作页
    brandCoop: {
      heroTitle:
        "卡宾坚信「共创」的力量——\n我们与品牌、艺术家、媒体携手打造具有文化感染力与商业价值的时尚项目。",
      mediaTitle: "媒体合作",
      starTitle: "明星/博主合作",
    },
    offlineStore: {
      real: "门店实景",
      navigateBtn: "导航到此门店",
      reviewTip: "欢迎在Google地图上为我们打分与评价：",
      reviewAction: "去评价",
    },
    findStore: {
      title: "寻找精品店",
      description: "通过平台如 TikTok、Instagram 等在线寻找我们的门店。",
      tiktok: "TikTok",
      instagram: "Instagram",
      amazon: "Amazon",
    },
    financialReport: {
      title: "财务报表",
      description: "在这里展示财务数据和报表。",
      all: "全部",
      loadMore: "加载更多",
    },
    productDetail: {
      purchaseContact: "如需购买请联系：",
    },
    // 添加更多翻译内容
    navbar: {
      store: "卡宾商城",
      about: "关于卡宾",
      offlineStore: "卡宾门店",
      contact: "联系我们",
      globalHQ: "全球总部",
      brandCooperation: "品牌合作/媒体与广告部",
      mallLeasing: "商场招商/品牌加盟",
      cooperation: "商务合作",
      recruitment: "人才招募",
      financialReport: " 财务报表/港股咨询",
      login: "登录",
      menFashion: "男士精品  >",
      cabbeenShoes: "卡宾潮鞋  >",
      newArrivals: "新品上新  >",
      trendAlbum: "潮流专辑  >",
      news: "品牌新闻",
    },
    // 商场招商/商场合作页面文案
    mallLeasing: {
      contactTitle: "商场招商/商场合作",
      position: "业务发展主管",
    },
    categories: {
      mensTops: "男士精品上装",
      tshirt: "T恤",
      shirt: "衬衫",
      suit: "西服",
      vest: "马甲",
      jacket: "夹克",
      polo: "POLO",
      sweatshirt: "卫衣",
      knitwear: "线衫",
      casualWear: "休闲装",
      mensBottoms: "男士精品下装",
      casualPants: "休闲裤",
      jeans: "牛仔裤",
      knitPants: "针织裤",
      shorts: "短裤",
      underwear: "内裤",
      cabbeenShoes: "卡宾潮鞋",
      casualShoes: "休闲鞋",
      sneakers: "板鞋",
      sandals: "拖凉鞋",
      "4dPrintedShoes": "4D打印鞋",
      accessories: "配件",
      bags: "箱包",
      hats: "帽子",
      belts: "腰带",
      necklaces: "项链",
      socks: "袜子",
      ties: "领带",
      newArrivals: "新品上新",
      celebrityStyle: "明星同款",
      fashionistaDiscount: "时尚达人限时折扣入口",
      pointsGifts: "积分礼品",
      pointsGift: "积分礼品",
    },
    footer: {
      company: "卡宾时尚（马来西亚）私人有限公司",
      address:
        "地址：L22-01 & 02, Wisma T.S.Law 55100 Kuala Lumpur.",
      mobile: "电话：03-8681 6097",
      emailLabel: "邮箱",
      website: "官网：WWW.CABBEENMY.COM",
      code: "股票代码：2030.HK",
      followUs: "关注我们：",
      terms: "版权所有 © 2025 卡宾时尚（马来西亚）私人有限公司",
      //domainInfo: "域名信息备案",
        // 页脚右侧导航（仅PC展示）
        nav: {
          shopTitle: "卡宾商城",
          contactTitle: "联系我们",
          aboutTitle: "关于卡宾",
          // 商城子项
          onlineStore: "在线商城",
          lazada: "Lazada",
          shopee: "Shopee",
          tiktokShop: "TikTok Shop",
          // 联系我们子项
          globalHQ: "全球总部",
          brandCooperation: "品牌合作/媒体与广告部",
          mallLeasing: "商场招商/品牌加盟",
          recruitment: "人才招募",
          // 关于卡宾子项
          offlineStore: "卡宾门店",
          news: "品牌新闻",
        },
    },

    // 明星大图
    celebrityTitleHtml:
      '<span class="zh">明星同款</span><span class="en">/CELEBRITY STYLE</span>',
    // 品牌价值观
    values: {
      items: [
        {
          title: "品牌理念",
          description: "卡宾服饰 颠覆流行",
        },
        {
          title: "品牌愿景",
          description: "用中华文化 树世界时尚品牌",
        },
        {
          title: "品牌使命",
          description: "专注品质，追求设计创意，持续满足人们多场景穿搭的需求",
        },
        {
          title: "核心价值观",
          description:
            "我们从事时尚工作，追求有品位的生活；不断提升和超越自己，我们营造展现个性、和谐、简单的工作环境；我们心怀感恩、服务社会，为中国创造时尚新生力量而努力。",
        },
        {
          title: "海外拓展计划",
          description:
            "CABBEEN 卡宾以吉隆坡为起点，持续拓展至印尼、新加坡、泰国、越南与柬埔寨，全面布局东南亚潮流版图。未来将创造 500+ 本地就业岗位，以 100% 资源投入与强势曝光，加速中国国潮走向世界。",
        },
      ],
    },
    about: {
      look: "查看",

      intro: [
        "卡宾服饰（Cabbeen Fashion，简称卡宾）创立于 1997 年，其'颠覆流行'的品牌理念，始终领先一步的个性时尚定位以及对原创设计的坚持与付出，使卡宾成为今日中国领先设计师品牌。2007 年 2 月，卡宾成为首个登上纽约时装周的中国设计师品牌。2013 年 10 月，卡宾服饰成功在香港上市，成为首家在香港上市的中国时尚服装设计师品牌（股票代码：2030）。",
        "作为从中国本土成长起来的标志性设计师品牌，卡宾专注于服装、鞋类与配饰的原创设计、品牌运营与多元零售渠道建设。在中国服装协会的权威评选中，卡宾凭借出色的零售收入、广泛的终端网络及卓越的品牌影响力，持续位列行业前列，充分展现其在中国时尚产业中的领先地位",
        "创建至今，卡宾服饰一直秉持'经营以提升品牌价值为纲，管理以建设人力资源为本'的经营理念，不断构建与完善国际化经营模式。旗下已形成以Cabbeen为核心、2AM、1%、Cabbeen、Love、CabbeenHome、KOYO、MARKETLIBERTY、thisisIZI8多品牌矩阵，延伸至时尚家居、时尚生活服务领域的品牌矩阵",
        "为了让海外的消费者能够更便捷地体验并选购卡宾的潮流服饰，该品牌正式宣布将其首家海外旗舰店落户于马来西亚吉隆坡Pavilion Bukit Jalil，并于6月8日举行盛大的开业典礼，标志著卡宾国际化战略迈出关键一步。",
      ],
    },
    news: {
      look: "查看",
      // 关于卡宾页面中的新闻模块卡片
      cards: [
        {
          title: "卡宾海外首店亮相大马Pavilion Bukit Jalil正式开业",
          summary:
            "卡宾服饰（Cabbeen Fashion）作为中国领先的设计师时尚品牌，6月8日在吉隆坡Pavilion Bukit Jalil迎来海外首店盛大开幕...",
        },
        {
          title: "2013年，中国设计师品牌CABBEEN卡宾在香港上市",
          summary:
            "2013年10月28日，作为中国领先的原创设计师品牌，CABBEEN卡宾公司在香港交易所挂牌上市。早在上世纪九十年代，全球掀起一场男性...",
        },
        {
          title: "CABBEEN卡宾成为首个登上纽约时装周的中国设计师品牌",
          summary:
            "纽约时间2007年2月3号 20:00，中国男装品牌CABBEEN卡宾在纽约时装周举行 2007/08 秋冬时装发布会...",
        },
        {
          title: "2024 FW/海丝景观《万物归心》秋冬发布会",
          summary:
            "2024年10月25日，海丝景观大秀《万物归心》暨CABBEEN卡宾2024/25秋冬发布会在泉州的石狮林銮渡码头举行....",
          link: "/news/malaysia"
        },
        // 2025SS 新增卡片（中文）
        {
          title: "CABBEEN卡宾xFengChenWang 2025春夏联名",
          summary: "CABBEEN卡宾xFengChenWang 2025春夏联名系列发布【家乡制造3.0】",
          link: "/news/2025-ss"
        },
        // 点赞卡片（中文）
        {
          title: "点赞!卡宾助力长八遥三火箭发射圆满成功",
          summary:
            "2024年，受邀作为“长征五号遥七、长征五号遥八、长征八号遥三、长征二号F遥十九、神州十九号载人飞船任务，长征七号遥九“",
          link: "/news/thumbsup"
        },
        // 2022 北京冬奥会（中文卡片）
        {
          title: "2022年助力北京冬奥会护旗手服装制作与生产",
          summary:
            "2022年，助力北京冬奥会，承接奥林匹克委员会护旗手服装的制作与生产，推动国家形象工程建设。",
          link: "/news/bjwo"
        },
      ],
      malaysia: {
        title: "卡宾海外首店亮相大马Pavilion Bukit Jalil正式开业",
        content1:
          "卡宾服饰（Cabbeen Fashion）作为中国领先的设计师时尚品牌，6月8日在吉隆坡Pavilion Bukit Jalil迎来海外首店盛大开幕。自1997年成立以来，卡宾始终秉持“年轻、时尚、个性”的理念，将东方美学融入国际潮流，深受全球都市男性喜爱。此次进驻大马，标志著卡宾国际化战略的重要一步，旨在为大马消费者打造融合潮流风格与生活品位的全新购物体验。",
        content2:
          "卡宾不仅在中国拥有强大的品牌号召力，其时尚影响力更已拓展至亚洲多个国家与地区，尤其是在我国，卡宾迅速赢得了本地消费者的广泛认可与喜爱。",
        content3:
          "为了让大马的消费者能够更便捷地体验并选购卡宾的潮流服饰，该品牌正式宣布将其首家海外首店落户于吉隆坡Pavilion Bukit Jalil，并于6月8日举行盛大的开业典礼，标志著卡宾国际化战略迈出关键一步。",
        content4:
          "ps：卡宾海外首店落户于吉隆坡Pavilion Bukit Jalil，并于6月8日举行盛大的开业典礼。",
        content5:
          "卡宾服饰（马）有限公司广告部经理毛倩倩（Mandy）在开业典礼上致词时指出，自品牌创立以来，卡宾始终致力于为新一代都市男性打造有态度、有风格的穿搭体验。",
        content6:
          "图说：毛倩倩：经过20多年的深耕发展，卡宾已在全球多个城市建立起稳固的品牌影响力，并赢得了广泛的认可与喜爱。",
        content7:
          "“今天，卡宾正式落地大马，不仅是我们国际化战略的关键一步，更体现了我们对东南亚时尚消费市场的高度重视与信心。吉隆坡作为一个活力四射、文化多元且极具时尚敏感度的城市，正是卡宾拓展新篇章的理想舞台。对此，我要特别感谢我们在大马的本地合作伙伴、零售团队以及每一位为本次开业倾情付出的同仁。正是因为你们的专业与热情，才让这家店铺从构想到落地，完美呈现在大家眼前。”",
        content8:
          "出席贵宾包括柏威年高级租务部董事何伟宏、卡宾执行董事许伟健、执行助理汤裕冰、店长朱立升及符福量等。",
        content9:
          "图说：符福量（左2起）、朱立升、许伟健、何伟宏、毛倩倩及汤裕冰为卡宾海外首店主持剪彩开幕仪式。",
        content10: "■25年设计沉淀 3年布局正式启动",
        content11:
          "随后，毛倩倩在接受《中国报》专访时透露，卡宾希望把东方设计美学与全球潮流趋势融合，为本地消费者带来耳目一新的购物体验。并且卡宾此次进军大马，以其为中心，开启面向东南亚市场的全布局，并在3年同步进入印尼、新加坡、泰国、越南、柬埔寨等国家，托管东南亚区域潮流设计和营销方向。",
        content12:
          "图说：何伟宏亦亲自试穿卡宾服饰，现场感受其独特设计与时尚魅力。",
        content13:
          "谈及为何选择将卡宾海外首店落户大马，她解释，选择我国是基于多方面的考量。首先，语言和文化的相通性，能够大幅度降低我们与市场、消费者之间的沟通成本。并且，正因为这里流淌着多元文化的基因，即华人、马来人、印度人的审美在此交融。这种文化包容性与卡宾“东方美学，国际表达”的品牌DNA高度契合。",
        content14:
          "“同时，我们也非常重视本地人才的发展与就业带动作用，希望通过卡宾的落地运营，推动本地零售,时尚及相关服务业的发展。在经济与文化层面搭建起中国与大马之间的友谊桥梁，以品牌为媒介，促进双边关系的深入与多元化。”",
        content15:
          "“我们之所以选择Pavilion Bukit Jalil作为海外首店的落点，是因为这里作为新兴商圈，兼具发展潜力、人流密集与商业氛围活跃等多重优势。同时，在大马的中高端时尚市场中，专注男装的品牌仍较为稀缺，卡宾希望借此切入点，填补市场空白，激发更多可能性，全面开启在大马的品牌新篇章。”",
        content16: "图说：卡宾海外首店盛大开业，吸引众多民众到场参观打卡。",
        content17:
          "“未来3年内，卡宾将在大马稳步推进品牌布局，计划在2年内开设6家门店，并在3年内实现全马的城市都布有卡宾的门。我们将大马作为卡宾国际化战略的重要起点。会在这里进行大规模的广告投入，初期投入预算将不低于3000万令吉。这将主要用于三个方面，即卡宾品牌门面形象的全面铺设，打造具辨识度的视觉形象、明星代言与博主合作推广，通过娱乐与社交媒体相结合的传播方式，快速建立品牌认知，以及积极参与本地公益项目，希望通过实际行动回馈社会，拉近与本地消费者的距离。”",
        content18:
          "她透露，接下来的重点工作是筹备由卡宾总部主导在中国福建泉州的大型时装秀活动。",
        content19:
          "“我们将会邀請各位商界友人前往參加。此外，我们也将陆续推进门店开业计划，届时会邀请香港TVB艺人或中国内地明星亲临剪彩，提升品牌声量和关注度。这些活动将进一步巩固我们在本地市场的影响力。”",
        content20:
          "她说，选址方面，第一阶段将以吉隆坡为核心区域进行布局，随后逐步拓展至新山、槟城、以及马六甲等主要城市，力求覆盖大马的重点市场。同时，卡宾也计划于明年正式上线线上销售渠道，实现线上线下双渠道同步发力，为消费者提供更便捷、多元的购物体验。",
        content21:
          "“卡宾始终坚信‘每一件事都值得专注地做好’。因此，在当前阶段，我们将以卡宾主品牌的稳健发展为首要任务，专注夯实品牌在大马市场的基础。待市场基础成熟后，才会适时考虑引入旗下其他子品牌，如面向年轻客群的2AM，以及聚焦童装市场的Cabbeen Love，以实现品牌矩阵的逐步拓展。",
        content22:
          "谈及卡宾与其他男装品牌的差异，毛倩倩认为卡宾最大的优势在于将设计的独特性与品质实现了理想的平衡。",
        content23:
          "“我们的定位处于亲民且合理的中高端区间，让更多消费者能够轻松拥有兼具设计感与实穿性的时尚单品。一直以来，卡宾始终坚持对细节、面料与穿著体验有著高标准要求。以我们这家首店的服装陈列为例，从商务Polo到运动休闲外套，都充分展现了卡宾‘有态度、有风格’的设计理念。许多顾客初看长袖单品会担心穿著过热，但实际上，我们采用的是轻盈和透气面料，即使在东南亚高温湿润的气候条件下，也能保持出色的舒适度，非常适合户外活动或运动穿著。”",
        content24:
          "她补充，卡宾不仅仅是一个时尚品牌，更是一种生活态度与文化品位的体现。她希望每一位穿上卡宾的消费者不仅穿出风格，更能感受到一种精神上的共鸣与认同。",
        content25:
          "“我们希望卡宾不仅成为大马消费者喜爱的男装品牌，更能打造一个融合潮流、美学与文化体验的时尚空间。希望大家在这里不仅能体验卡宾以客为尊的购物体验，也能感受到卡宾所倡导的生活方式与品牌精神。”",
        content26:
          "图说：舞狮采青仪式后，众贵宾与卡宾职员合影留念，齐声祝愿卡宾生意兴隆、开业大吉。",
      },
      nyShow: {
        title: "CABBEEN卡宾成为首个登上纽约时装周的中国设计师品牌",
        content1:
          "纽约时间2007年2月3号 20:00，中国男装品牌CABBEEN卡宾在纽约时装周举行 2007/08 秋冬时装发布会。从后台的模特、穿衣工到前台的主设计师卡宾先生及CABBEEN演出代表团均受到了广泛的关注，这是中国设计师品牌首次在以时尚性和商业性闻名全球的纽约时装周上亮相。",
        content2:
          "CABBEEN卡宾发布会展示的 40 套 2007/08 秋冬男装对中国传统文化元素进行了大胆独特的诠释，引起了国际时装界和专业媒体人的震惊与赞誉。纽约邮报在其关于时装周的预览报道中写道：“纽约国际时装周共有 130 多场秀，其中有十场是必看的秀，CABBEEN卡宾男装排前五”。被设计师、作家和艺术家推崇为风格与时尚权威的《VOGUE》杂志也以 “中国品牌首登纽约时装周” 为题作了重点报道。",
      },
      hklisting: {
        title: "2013年，中国设计师品牌CABBEEN卡宾在香港上市",
        content1:
          "2013年10月28日，作为中国领先的原创设计师品牌，CABBEEN卡宾公司在香港交易所挂牌上市。",
        content2:
          "早在上世纪九十年代，全球掀起一场男性审美变革，打破几百年来男装设计程式化、功能化的特点，CABBEEN卡宾率先跨出第一步，细致的表达人体线条，让服装更合体，卡宾的男装腰线设计在中国男装设计里程中犹如一座分水岭，重新界定了男性美，构建了一种全新的中国男性形象。回顾卡宾的发展脉络不难发现，卡宾一直秉承“颠覆流行”的品牌理念，不仅在设计上打破陈腐旧套，在经营管理上也敢于做出新的尝试。CABBEEN卡宾在港股的成功上市，展现出卡宾一往无前的勇气和舍我其谁的气势。",
      },
      fw2024: {
        title: "2024 FW/海丝景观《万物归心》秋冬发布会",
        content1:
          "近年来，泉州成为新晋旅游热门城市，当地的历史文化沉淀与城市魅力吸引了不少年轻消费者前去打卡，多个明星综艺也相继来到泉州取景拍摄，甚至越来越多的时尚品牌、时尚杂志也都涌入泉州举办高规格的时尚活动、拍摄明星大片等等，多方流量叠加引爆关注，充分展现了泉州的在地文化魅力。",
        content2:
          "而同样来自泉州的CABBEEN卡宾品牌主理人卡宾先生，也选择了重返故乡石狮，举办CABBEEN卡宾2024/25秋冬季发布会，带来耳目一新的秀场惊喜，引发业界及时装爱好者的广泛关注和热烈讨论，火速晋升时尚圈的话题中心。",
        content3:
          "值得关注的是，10月25日当天，毕雯珺、陈晓东、吉克隽逸、梁汉文、林晓峰、吕颂贤、马苏、吴宣仪、向佐、张亮（按姓名首字母排序）等一众明星亮相泉州石狮林銮渡码头，观看「万物归心」CABBEEN卡宾泉州石狮大秀。星光熠熠的明星阵容成为了这场大秀极为出圈的元素，为CABBEEN卡宾及泉州带来了超高的曝光度和关注度，拉近了品牌与消费者的对话距离。",
        content4:
          "此外，现场还有超过50+位时尚博主、全国知名购物中心的高层领导、各大时尚杂志出版人、服装品牌创始人、电商平台、时尚媒体、商业媒体等一同前来观秀，共同见证“万物归心”以及CABBEEN卡宾耀眼的27周年。",
        content5: "「万物归心」海丝景观大秀",
        content6: "构建全新秀场体验",
        content7:
          "回顾品牌过往，CABBEEN卡宾屡屡打造出了无数场精彩的品牌发布会，2007年成为首个走上纽约时装周的中国设计师品牌、2015年举办《Funfair》游乐场主题大秀、2021年的《新世观》城市街头大秀……我们看到了CABBEEN卡宾以原创设计及无限创意所构建的一个个不同主题、不同概念、不同形式的时尚舞台。",
        content8:
          "这一次，品牌再次颠覆过往，卡宾先生特别携手国家级著名导演肖向荣导演，选址海上丝绸之路的重要节点——泉州石狮林銮渡码头，以「万物归心」为主题，一同举办CABBEEN卡宾2024/25冬季发布会，在历史文化与时装艺术的碰撞中以一种全新的叙事方式呈现。",
        content9:
          "作为海上丝绸之路的发源地，泉州石狮蕴藏着无数传奇的人文故事，CABBEEN卡宾大秀本次的所在地——林銮渡码头，它建于唐代，距今已有千年历史，全长113.5米，既是东西方文化交流的重要桥梁，也见证了无数文化的交融与历史变迁。它表达了同样来自泉州的卡宾先生对于家国的深厚情感，以及对品牌27年发展历程的深思与展望。",
        content10:
          "大秀发布前夕，卡宾先生还登上《风度》杂志封面，并拍摄短视频三部曲《见境》、《见心》、《见行》，借泉州石狮家乡之情，言万物“归”心之志。",
        content11:
          "“半城烟火半城仙” 完美诠释了泉州这座城市的独特魅力。卡宾先生心中满载着对故乡的热爱，“泉州，不仅有美食，有世界文化遗产、民间传统文化、还有独特的簪花文化体验等，“半城烟火”是形容闽南人民的勤劳与朴实，“半城仙”则体现了泉州极大的包容度，包容来自全世界的人们来这里创业和生活。”",
        content12:
          "大秀当天，卡宾先生与大秀主创团队首次将T台延伸到了海上，将千年码头打造成华丽的舞台。秀场设计以CABBEEN卡宾黄为主色调，巨型双「C」 LOGO装置伫立在码头上。伴随着精彩的非遗表演，观众们在时间舞蹈者的带领下，从旧码头走到新码头，在落日余晖的光影之间，精彩呈现了一场沉浸式的海丝景观大秀。",
        content13:
          "卡宾先生表示，“新旧码头的交融，就像我的人生轨迹，从满怀力量的拳击少年，到一手打造出CABBEEN卡宾集团。中华文化作为CABBEEN卡宾品牌的底色，无时无刻滋养着我的作品，我会始终带领品牌，以中华文化为DNA，带来更多中国原创设计。”",
        content14: "以中华文化为纽带 开启跨界联名的新篇章",
        content15:
          "聚焦本次大秀新品，CABBEEN卡宾依旧带来了不少惊喜。当晚最大的亮点，是来自CABBEEN卡宾与国际时装周品牌FengChenWang携手推出的2025春夏联名系列MADE IN MY TOWN 3.0「故乡制造3.0」，成为了这场大秀最出圈的元素。",
        content16:
          "联名系列的重磅首发，以卡宾先生与设计师王逢陈共同的故乡泉州为灵感，巧妙萃取福建茶饮精髓之色，融合王逢陈独特的解构拼接设计，以及CABBEEN卡宾特色洗水工艺，打造先锋户外休闲风格，呈现全新多品类联名服装系列。",
        content17:
          "CABBEEN卡宾作为FengChenWang在国内唯一的联名合作的品牌，双方于2020年达成首次合作至今，共同携手打造了多个联名系列。今年1月，CABBEEN卡宾联合媒体《上城士》，同样选择在泉州，为CABBEEN卡宾X FengChenWang 2024春季设计师联名系列「家乡制造2.0」举办发布仪式「上城家宴」。",
        content18:
          "紧接着登场的是CABBEEN卡宾 x 中国火箭2024冬季联名系列「极地行者」，品牌延续宇宙极地探索的故事，以宇宙信号波、月球地貌及未来宇航服等为灵感，从而设计创作出富有先锋肌理质感的「极地行者」系列作品：具有太空户外风格的夹克、马甲、羽绒服等单品。",
        content19:
          "此外，CABBEEN卡宾现场也发布了全新的「绒耀玩家」系列、赛里木湖羽绒系列等作品，这些新品代表了CABBEEN卡宾及卡宾先生对中国力量的致敬和对时尚新的理解。",
        content20:
          "可见，CABBEEN卡宾尤其重视挖掘传统文化并结合服装的多面性，试图通过破界亦或连结中华文化与时尚设计语言的界限，通过一次次的跨界联名来保持新鲜度，实现“破圈”，以适应瞬息万变的时尚潮流市场。",
        content21:
          "一直以来，中华文化是CABBEEN卡宾品牌的底色，卡宾先生始终带领品牌，以中华文化为DNA，持续创造中国原创设计。2024年，CABBEEN卡宾的联名活动也从未停歇，持续带来不少跨界联名系列，包括备受喜爱的“CABBEEN卡宾x中国火箭”以及“CABBEEN卡宾x FengChenWang”联名系列，不仅深化消费者对品牌跨界合作的认知，也拉近与消费者的距离。",
        content22:
          "随着大秀的圆满落幕，CABBEEN卡宾原创设计再次成为时尚圈的话题点。#CABBEEN卡宾2024/25秋冬发布会、#CABBEEN卡宾泉州石狮大秀等各种热搜词条迅速活跃在各大媒体平台，为品牌持续造势声量。与此同时，CABBEEN卡宾全国400+核心商圈、800+门店也同频宣发, 让线上线下消费者也能更有参与感。",
        content23: "持续打造品牌力 深化品牌价值",
        content24:
          "回顾2023年，对中国时尚服装市场持续看好的卡宾先生，CABBEEN卡宾主品牌掀起了全球品牌升级计划，并展开了一系列颠覆性动作：重启双「C」logo，品牌VI蜕变、跨界联名、从产品力、视觉形象、内容传播以及店铺形象等方面进行革新升级，将品牌带向全新高度，也为消费者带来全新的视觉冲击。",
        content25:
          "其中，我们看到，CABBEEN卡宾在终端渠道形象升级方面今年再次取得了明显突破，以「CABBEEN卡宾黄」为内核的全新面貌，在消费者心中加强了品牌鲜明的印记，以更年轻、更潮流的场景空间向消费者渗透品牌价值。",
        content26:
          "就在刚过去不久的8月，CABBEEN卡宾广州正佳全国旗舰店揭幕，带来了全新门店形象颠覆升级，通过构建多元创新的全品类空间，融合视、听、嗅三觉打造先锋美学空间，带来沉浸式的感官体验。店内不仅有全国首个裸眼3D球型大屏，还有全国首个品牌旗舰VIP室，首度发布10大VIP至尊特权。从业绩上看， CABBEEN卡宾广州正佳店开业以来，销售同比增加30%，新会员增长25%，也验证了品牌今年调整的策略符合市场及消费者的期待。",
        content27:
          "截至发稿日，CABBEEN卡宾全国共有650家店，其中购物中心店有420家。据品牌方透露，2025年计划开150家店，未来继续积极加大国内市场的投入，继续加密核心商圈及优质购物中心的渠道布局，进一步提升品牌影响力。",
        content28:
          "2024年，是CABBEEN卡宾成立27周年，卡宾先生带领品牌一路砥砺前行，为中国消费者带来更多原创设计、更多新的惊喜，持续为中国时尚产业升级贡献力量。回到这场海丝景观大秀，它的存在某种意义上，也象征着CABBEEN卡宾坚守品牌初衷，以泉州石狮为起点，链接世界的决心。",
      },
      // 2025SS 详情（中文占位，后续可补充更多段落）
      ss2025: {
        title: "CABBEEN卡宾xFengChenWang 2025春夏联名",
        summary: "CABBEEN卡宾xFengChenWang 2025春夏联名系列发布【家乡制造3.0】",
      },
      // 点赞详情（中文）
      thumbsup: {
        title: "点赞!卡宾助力长八遥三火箭发射圆满成功",
        summary:
          "2024年，受邀作为“长征五号遥七、长征五号遥八、长征八号遥三、长征二号F遥十九、神州十九号载人飞船任务，长征七号遥九“",
        content1:
          "3月20日8时31分，探月工程四期鹊桥二号中继星由长征八号遥三运载火箭在中国文昌航天发射场成功发射升空。长征八号遥三运载火箭飞行24分钟后，星箭分离，将鹊桥二号中继星直接送入预定地月转移轨道。中继星太阳翼和中继通信天线相继正常展开，发射任务取得圆满成功。",
        content2: "长八遥三运载火箭试验队工作人员与火箭合影",
        content3: "助长八 搭“鹊桥”",
        content4: "卡宾以广东设计为中国航天助力",
        content5:
          "作为中国设计师品牌，CABBEEN卡宾一直紧密关注中国航天事业发展，并自2021年起为火箭试验队队员设计与开发专业队服，以中国原创设计力量与先进服装技术，诠释中国航天精神。本次发射任务，广东省服装服饰行业协会顾问、CABBEEN卡宾品牌主理人卡宾先生受邀担任长八遥三火箭试验队队服的设计师，搭建与试验队员的“连心桥”。",
        content6: "卡宾先生荣获长八遥三运载火箭荣誉证书",
        content7: "卡宾先生为长八遥三火箭试验队设计的新队服",
        content8: "长八遥三火箭试验队工作人员身穿队服",
        content9:
          "CABBEEN卡宾一直以“用中华文化，树世界时尚品牌”为愿景，致力于用中国原创设计提升国家形象,传递国家文化自信。飞天逐梦,剑指苍穹,探索之路，同心同行!CABBEEN卡宾充分发挥中国原创设计力量，以服装语言呈现航天人自信而强大的风采，为中国航天发展乃至国家事业贡献广东服装力量!",
        content10: "致敬中国航天",
        content11: "为卡宾点赞！",
        content12: "为广东服装点赞！",
      },
      // 2022 北京冬奥会详情（中文）
      bjwo: {
        title: "2022年助力北京冬奥会护旗手服装制作与生产",
        summary:
          "2022年，助力北京冬奥会，承接奥林匹克委员会护旗手服装的制作与生产，推动国家形象工程建设。",
        content1: "北京冬奥会开幕式现场",
        content2:
          "2022年北京冬奥会开幕式处处彰显着“中国智造”的科技底色，Cabbeen卡宾运用“互联网+”技术，全流程数字化、系统自动化的“智能制造”工厂，携手设计师王逢陈打造会旗护旗手服装，向大家展示时尚与庄严并重的形象。",
        content3:
          "奥林匹克会旗护旗手服装由年轻的设计师王逢陈设计，Cabbeen卡宾制作。艺术印花羽绒服外套可以看到来自《千里江山图》的重新演绎，这幅经典名画不仅展现了当时浩渺的江河、层峦起伏的群山群像，它还象征着同一世界下人与自然、人与世界间的相融与相连。",
        content4:
          "设计师王逢陈用中国传统的山水国画元素作为背景，在外套上运用渐变的色彩晕染，同时嵌入白描手法的艺术形式，绘制具有代表性的中国历史建筑和奥运会标志性建筑，勾勒历史与现代相连的筋骨。",
        content5:
          "Cabbeen卡宾则运用“互联网+”技术，全流程数字化、系统自动化的“智能制造”工厂实现了设计师的创意，在重塑传统的同时，使其又拥有独特、现代的气质。",
        content6:
          "卡宾先生说，这次参与北京冬奥会开幕式服装的制作，开启了他对于服装更广阔的思路，“我们也希望在未来服装不仅仅是装扮，更是一种装备，美观和功能性并存。”",
        content7: "卡宾先生",
        content8: "Cabbeen卡宾服饰主理人中国著名设计师、金顶奖得主",
        content9: "Q-北京青年周刊",
        content10: "A-卡宾先生",
        content11:
          "Q 看到有关冬奥会护旗手的文字，提到了“智能制造工厂”的概念，“智能制造工厂”创立的初衷是怎样的， “智能制造工厂”制造出来的服装，具备哪些特点？",
        content12:
          "A现代社会瞬息万变，我们顺应时代的进步，工艺和技术也会对应更新换代，“智能制造工厂”的创立是一种突破也是一种进步，像本次Cabbeen卡宾运用“互联网 +”技术，全流程数字化、系统自动化的“智能制造”工厂把最前沿的技术应用到设计制作当中，用精湛及严谨的工艺打造具备功能性与舒适性的服装。比如，设计方案成型之后，一个月时间内保质保量完成交付，比如前胸五环LOGO是最先进的烫画工艺。",
        content13:
          "科技的进步让制作的速度增加了，材料快速到位，短期内（5-7天）快反应8+8套样板制作以及大货生产；印花图案由卡宾团队安排多尺寸需求填图；克服了五环LOGO烫画的困难：图案较小，羽绒化纤面料很滑，烫画牢度存在较大风险，经过多家工艺厂以及多次测试，最终结果达成标准。",
        content14:
          "Q 为了进行冬奥会的设计制作，你做了哪些准备？采风了哪些传统的中国元素？跟设计师王逢陈是怎样进行合作的？",
        content15:
          "A王逢陈是中国先锋设计师的代表之一，也是卡宾长期合作的跨界设计师，而且我们碰巧都来自福建，因缘际会加上理念相同让我们再度在冬奥服装合作。由王逢陈设计，Cabbeen卡宾负责本次服装的制作与生产，携手为冬奥会助力。",
        content16: "设计师王逢陈与护旗手在后台",
        content17:
          "Q 你是怎样把中国元素和当代性时代感相结合的？怎样既能体现中国气质又能体现冰雪质感，能够展现未来？",
        content18:
          "A本次我们共同打造的护旗手服装分别由艺术印花羽绒服外套和中式西服白色套装组合而成，其中的灵感来自于《千里江山图》的重新演绎。这幅经典名画不仅展现了当时浩渺的江河、层峦起伏的群山群像，它还象征着同一世界下人与自然、人与世界间的相融与相连。设计师王逢陈用中国传统的山水国画元素作为背景，在外套上运用渐变的色彩晕染，同时嵌入白描手法的艺术形式，绘制具有代表性的中国历史建筑和奥运会标志性建筑，勾勒历史与现代相连的筋骨。这些都是十分经典的中国元素和冰雪的互相映衬，摆脱了过往的陈旧形象，是一幅推陈出新的代表中国的新面貌。",
        content19:
          "Q 冬奥会的服装还具有一个功能性，就是保暖，现在网络上都在讲，冬奥会是一个羽绒服的比赛，科技上是怎样实现保暖的？你怎么看科技的创新？",
        content20:
          "A拿羽绒服来说，过往的科技可能只能做到保暖，我们的羽绒科技更注重功能性的更新，运用杜邦Teflon三防顶级面料、3D荷叶纳米效应（这是一种仿生技术，用荷叶的光滑度以及抗污功能做比喻，在荷叶上泼水不会沾水），所以这些面料能够充分达到防寒、防风、防水的效果。",
        content21:
          "时代进步，技术更新换代是很自然而为的事情，随着我们的生活场景的转变，品牌也会通过升级技术来提升产品的质量满足客户，提升速度满足时代的快速运转。除了技术之外，卡宾的设计也坚持颠覆流行，我们会在“不变”的品牌内核之下，不断突破技术和设计，致力发展中国原创设计。",
      },
    },
  },
};

const i18n = createI18n({
  legacy: false, // ✅ 关键点：关闭 legacy 模式
  locale: "en", // 默认语言为英文
  messages,
});

export default i18n;

